module.exports = __webpack_public_path__ + "static/media/c-sharp-beginner.f7b488db.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/validations/images/levels/c-sharp-beginner.png
// module id = 1458
// module chunks = 147